import { useState, useContext } from 'react';
import isEmpty from 'lodash/isEmpty';
import { AppContext } from 'commons-ui';

import { ContentPropsT } from './constants';

const useContent = (props: ContentPropsT) => {
	const { handleFilterSubmit, onClose } = props;

	const [showLoader, setShowLoader] = useState(false);
	const { showAlert } = useContext(AppContext);

	const handleFormSubmit = async (submittedData: any) => {
		try {
			setShowLoader(true);
			const { merchantName, orderId } = submittedData;
			if (!isEmpty(merchantName) && !isEmpty(orderId)) {
				handleFilterSubmit({ merchantName, orderId });
			}
			setShowLoader(false);
		} catch (error) {
			showAlert('Error in fetching PayIn details', { type: 'error' });
		} finally {
			onClose();
		}
	};

	const handleFormCancel = () => {
		onClose();
	};

	return {
		showLoader,
		setShowLoader,
		handleFormSubmit,
		handleFormCancel
	};
};

export default useContent;
